import { default as MuiTableCell, TableCellProps } from '@mui/material/TableCell'
import * as React from 'react'

const TableCell: React.FC<React.PropsWithChildren<TableCellProps>> = (props) => <MuiTableCell {...props} />

export default TableCell
